import produce from 'immer'

import {
  DeliveryForecastItemForecast,
  DeliveryForecastItemPreviousDelivery,
  DeliveryForecastItemSplit,
} from '../../../../data/models'

interface ConvertedResponse
  extends Omit<
    | DeliveryForecastItemPreviousDelivery
    | DeliveryForecastItemSplit
    | DeliveryForecastItemForecast,
    'Date' | 'BuyerDeliveryDate' | 'ConfirmationDeliveryDate' | 'DeliveryDate'
  > {
  Date: Date
  BuyerDeliveryDate: Date
  ConfirmationDeliveryDate: Date
  DeliveryDate: Date
}

/**
 * Converts a list of delivery forecast items into a list of converted item objects.
 *
 * This function uses the Immer library to create a new array of converted items objects from
 * the provided array of delivery forecast items. The conversion process involves:
 *
 * 1. Transforming date strings into Date objects for easier filtering and sorting in tables.
 *
 * @param {DeliveryForecastItemPreviousDelivery[] | DeliveryForecastItemSplit[] | DeliveryForecastItemForecast[] | undefined} items - The list of delivery forecast items to be converted.
 * @returns {ConvertedItems[]} - The list of converted delivery forecast items.
 */
export function convertDeliveryForecastItems(
  items:
    | DeliveryForecastItemPreviousDelivery[]
    | DeliveryForecastItemSplit[]
    | DeliveryForecastItemForecast[]
    | undefined,
) {
  // transforms date strings in date objects so it can be filtered in tables
  const convertedItems = produce(items, (draft: ConvertedResponse[]) => {
    draft?.forEach(response => {
      // Date
      response.Date = new Date(response.Date)

      // BuyerDeliveryDate
      response.BuyerDeliveryDate = new Date(response.BuyerDeliveryDate)

      // ConfirmationDeliveryDate
      response.ConfirmationDeliveryDate = new Date(
        response.ConfirmationDeliveryDate,
      )

      // DeliveryDate
      response.DeliveryDate = new Date(response.DeliveryDate)
    })
  })

  return convertedItems
}
